import { Typography } from "@mui/material";
import { CoreTextField } from "@verity/components/core";
import { ChangeEventHandler } from "react";

type FormTextFieldProps = {
	title: string;
	placeholder: string;
	required?: boolean;
	value: string;
	handleChange: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
	maxLength?: number;
	error?: string;
};

export default function FormTextField({
	title,
	placeholder,
	required = false,
	value,
	handleChange,
	maxLength,
	error,
}: FormTextFieldProps) {
	return (
		<>
			<Typography>
				{title}
				{required && <span> *</span>}
			</Typography>
			<CoreTextField
				size={"medium"}
				placeholder={placeholder}
				value={value}
				onChange={handleChange}
				error={error}
				maxLength={maxLength}
			/>
		</>
	);
}
